import { useEvent as i } from "../events.js";
import { useBindProp as c } from "../props.js";
import l from "./click.js";

function t(t, o) {
  l(t, o), c(t, {
    setter: "setClickable"
  }, o.clickable), i(t, "dblclick", o.onDblClick), i(t, "rightclick", o.onRightClick);
}

export default t;